'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');
const styles = require('./DetailsReturnModal.scss');
const copy = require('../../../../../json/copy/buyerAssuranceTrade.json');
const get = require('lodash.get');

const { ModalContainer, BarHeader, ModalCloseButton, ModalBody } = require('dibs-elements');

function Guarantee() {
    return (
        <div className={`${styles.guarantee}`}>
            <div className={`${styles.guaranteeLine}`} />
            <div className={`${styles.guaranteeHeader}`}>{copy.buyerProtection.header}</div>
            <span className={`${styles.guaranteeText}`}>
                {copy.buyerProtection.beforeLink}
                <a href={copy.buyerProtection.linkHref}>{copy.buyerProtection.linkCTA}</a>
                {copy.buyerProtection.afterLink}
            </span>
        </div>
    );
}

function DetailsReturnModal({ item = {}, isOpen = false, onClose = () => {} }) {
    const returnCopy = get(item, 'returnPolicy.buyerCopy.returnCopy') || '';
    const shippingResponsibility = get(item, 'returnPolicy.buyerCopy.shippingResponsibility');
    const tradeCopy = get(item, 'returnPolicy.buyerCopy.trade');
    const additionalNotesHeader = get(item, 'returnPolicy.buyerCopy.additionalNotesHeader');
    const note = get(item, 'returnPolicy.note');

    return (
        <ModalContainer
            dataTn="return-details-modal"
            onClose={onClose}
            isOpen={isOpen}
            modalPosition="center"
        >
            <BarHeader title={copy.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody className={styles.modalBody}>
                <div data-tn="return-modal-return-policy">
                    <div className={styles.returnPolicyLine}>{returnCopy}</div>
                    {shippingResponsibility && (
                        <div className={styles.returnPolicyLine}>{shippingResponsibility}</div>
                    )}
                    {tradeCopy && (
                        <div className={styles.returnPolicyLine}>
                            <div>{tradeCopy.shippingResponsibility}</div>
                            <div>
                                <a href={tradeCopy.returnLink.url}>{tradeCopy.returnLink.cta}</a>
                            </div>
                        </div>
                    )}
                    {note && (
                        <div
                            data-tn="return-modal-additional-notes"
                            className={styles.returnPolicyLine}
                        >
                            {additionalNotesHeader}: {note}
                        </div>
                    )}
                </div>
                <Guarantee />
            </ModalBody>
        </ModalContainer>
    );
}

DetailsReturnModal.propTypes = {
    item: PropTypes.object,
    userId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
};

module.exports = Relay.createContainer(DetailsReturnModal, {
    initialVariables: {
        userId: null,
    },
    fragments: {
        item: () => Relay.QL`
            fragment on Item {
                returnPolicy(userId: $userId) {
                    buyerCopy {
                        returnCopy
                        additionalNotesHeader
                        shippingResponsibility
                        trade {
                            shippingResponsibility
                            returnLink {
                                cta
                                url
                            }
                        }
                    }
                    note
                }
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsReturnModal.jsx